import { Injectable } from '@angular/core';
import { BaseDirectiveObject } from '../components/common/base-directive-object';
import { TasksViewPrefs, UserPrefs } from '../api/UserPrefs-dto';

import { AppState } from './AppState';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { AppConfiguration } from '../conf/app.configuration';
import { SET_USERPREFS } from './userPrefs';

@Injectable({
  providedIn: 'root'
})
export class UserPrefsService extends BaseDirectiveObject {

  private localUserPrefs: UserPrefs;

  constructor(protected appConfig: AppConfiguration, private store: Store<AppState>) {
    super();
    this.subscribe(store.select('userPrefs'), (prefs: UserPrefs) => this.localUserPrefs = prefs);
  }

  public getUserPrefs(): Observable<UserPrefs> {
    return this.store.select('userPrefs');
  }

  public setUserPrefs(prefs: UserPrefs): void {
    this.store.dispatch(SET_USERPREFS({ userPrefs: prefs }));
  }


  public init() {
    let modified = false;
    // inicializar la variable por si no viene en las preferencias
    let prefs = this.localUserPrefs;
    if (!prefs) {

      prefs = new UserPrefs();

      let defaultShowProfileValue = this.appConfig.getValue('TasksViewPrefs.showProfile.default');
      if (defaultShowProfileValue != undefined) {
        prefs.tasksViewPrefs.showProfile = defaultShowProfileValue;

      }

      modified = true;

    }

    if (!prefs.tasksViewPrefs) {
      prefs.tasksViewPrefs = new TasksViewPrefs();
      let defaultShowProfileValue = this.appConfig.getValue('TasksViewPrefs.showProfile.default');
      if (defaultShowProfileValue != undefined) {
        prefs.tasksViewPrefs.showProfile = defaultShowProfileValue;

      }
      modified = true;
    }




    if (modified) {
      this.localUserPrefs = prefs;
      this.store.dispatch(SET_USERPREFS({ userPrefs: prefs }));
    }

  }

  clear() {
    this.localUserPrefs = undefined;
    this.init();



  }


  // set store.dispatch método store
  // get propiedad
  //
}
